module.exports = __webpack_public_path__ + "static/media/layer8.a1878d81.svg";